import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { WizardStepper, WizardFooterBar, WIZARD_STEPS } from "./WizardStepper";
import { RoleStartupModal } from "./RoleStartupModal";
import { useRoleStore } from "@/shared/store/role";
import { useErrorToastStore } from "@/shared/store/errorToast";
import { Toast } from "@/shared/ui";

const HIDE_KEY = "lk2-sidebar-hidden";

export function Shell() {
  const { pathname } = useLocation();
  const inWizard = WIZARD_STEPS.some((s) => pathname.startsWith(s.path));
  const role = useRoleStore((s) => s.role);
  const errorMessage = useErrorToastStore((s) => s.message);
  const clearError = useErrorToastStore((s) => s.clear);

  const [sidebarHidden, setSidebarHidden] = useState(
    () => localStorage.getItem(HIDE_KEY) === "1",
  );

  const toggleSidebar = () => setSidebarHidden((h) => {
    const next = !h;
    localStorage.setItem(HIDE_KEY, next ? "1" : "0");
    return next;
  });

  return (
    <div className="flex h-screen bg-[var(--bg)]">
      <Sidebar hidden={sidebarHidden} />
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <Topbar sidebarHidden={sidebarHidden} onToggleSidebar={toggleSidebar} />
        {inWizard && role !== "blogger" && <WizardStepper />}
        <main className="flex-1 overflow-y-auto">
          <div className="fade-up min-h-full">
            <Outlet />
          </div>
        </main>
        {inWizard && role !== "blogger" && <WizardFooterBar />}
      </div>
      <RoleStartupModal />
      {errorMessage && <Toast message={errorMessage} onHide={clearError} variant="error" />}
    </div>
  );
}
